import type { ImageSource } from '@wlb/shared/types';
import {
  resolveProfilePictureUrl,
  resolveImageSource,
} from '@wlb/shared/utils/imageUrl';

/**
 * Resolves a profile/user picture path (string) to a full URL using the
 * shared `IMAGE_BASE_URL` config, skipping known placeholder images.
 */
export const resolvePictureUrl = (path?: string | null): string | null =>
  resolveProfilePictureUrl(path) ?? null;

/**
 * Resolves the platform-agnostic `ImageSource` (or a plain URL string) to a
 * URL string the web `<img>` can consume, using the shared image utilities.
 */
export const resolveImageUrl = (
  source: ImageSource | string | null | undefined,
): string | null => {
  if (source == null) return null;
  if (typeof source === 'string') {
    return resolveProfilePictureUrl(source) ?? null;
  }
  const resolved = resolveImageSource(source);
  if (resolved == null) return null;
  if (typeof resolved === 'number') return null;
  if (Array.isArray(resolved)) {
    const first = resolved[0];
    return first?.uri ?? null;
  }
  return resolved.uri ?? null;
};
